import { render } from "./FooterV.vue?vue&type=template&id=74ef059e&scoped=true"
import script from "./FooterV.vue?vue&type=script&lang=js"
export * from "./FooterV.vue?vue&type=script&lang=js"

import "./FooterV.vue?vue&type=style&index=0&id=74ef059e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef059e"]])

export default __exports__